module.exports = __webpack_public_path__ + "img/table.831c2ccd.svg";